import { Switch } from '@patrianna/core-components'
import { nextTick } from '@patrianna/shared-utils'
import cx from 'classnames'
import type { FunctionComponent } from 'react'

import { useAppSelector } from 'src/store/hooks'
import { getGoldCurrencySelector, getSweepstakeCurrencySelector } from 'store/modules/currencies/selectors'
import { DescribeSwitcherCurrency } from 'store/modules/currencies/utils'
import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

type CashSwitcherType = {
  activeCurrency: string
  mode?: string
  handleChange: (data: { activeCurrencyId: SupportedCurrencies }) => void
  reversed?: boolean
  GoldCurrencyComponent?: FunctionComponent
  SweepstakeCurrencyComponent?: FunctionComponent
  dataAttribute: string
  collapseCurrency?: boolean
}

function CashSwitcher(props: CashSwitcherType) {
  const { GoldCurrencyComponent, SweepstakeCurrencyComponent } = props

  const goldCurrency = useAppSelector(getGoldCurrencySelector)
  const sweepstakeCurrency = useAppSelector(getSweepstakeCurrencySelector)

  const handleChange = () => {
    nextTick().then(() => {
      if (DescribeSwitcherCurrency[props.activeCurrency]) {
        props.handleChange({ activeCurrencyId: 'GC' })
      } else {
        props.handleChange({ activeCurrencyId: 'SC' })
      }
    })
  }

  if (!goldCurrency || !sweepstakeCurrency) {
    return null
  }

  return (
    <div
      onClick={handleChange}
      className={cx(classes.root, { [classes.reversedRoot]: props.reversed, [props.mode]: props.mode })}
      data-test={`cash-switcher-${props?.dataAttribute}`}
    >
      <div className={cx(classes.switcherWrap, props.mode && props.mode)}>
        <Switch
          data-test={`cash-switch-${props?.dataAttribute}`}
          checked={DescribeSwitcherCurrency[props.activeCurrency]}
          onChange={handleChange}
          className={cx(classes.switcher, props.mode && props.mode)}
          thumbClassName={cx(
            classes.thumb,
            DescribeSwitcherCurrency[props.activeCurrency] ? classes.switcherOn : classes.switcherOff,
          )}
          trackClassName={classes.track}
        />
      </div>

      {!props.collapseCurrency && (
        <div className={cx(classes.labels, props.reversed && classes.reversedText)}>
          <div
            role='button'
            className={cx(classes.label, !DescribeSwitcherCurrency[props.activeCurrency] && classes.active)}
            onClick={handleChange}
          >
            {GoldCurrencyComponent && goldCurrency ? <GoldCurrencyComponent /> : 'Gold Coins'}
          </div>

          <div
            role='button'
            className={cx(
              classes.label,
              classes.labelMobile,
              DescribeSwitcherCurrency[props.activeCurrency] && classes.active,
            )}
            onClick={handleChange}
          >
            {SweepstakeCurrencyComponent && sweepstakeCurrency ? <SweepstakeCurrencyComponent /> : 'Sweepstakes Coins'}
          </div>
        </div>
      )}
    </div>
  )
}

export default CashSwitcher
